<div class="firma-container">
  <!-- Título de la sección -->
  <div class="section-header mb-4">
    <h5 class="mb-2">
      <i class="fa fa-edit text-primary me-2"></i>
      Gestión de Firma Digital
    </h5>
    <p class="text-muted small mb-0">Selecciona el método de captura de firma que prefieras</p>
  </div>

  <!-- Selector de modo -->
  <div class="btn-group w-100 mb-4" role="group">
    <button 
      type="button" 
      class="btn btn-lg mode-btn" 
      [class.btn-primary]="modoFirma === 'dibujar'"
      [class.btn-outline-primary]="modoFirma !== 'dibujar'"
      (click)="cambiarModo('dibujar')">
      <i class="fa fa-pencil-square-o me-2"></i>
      <span class="btn-text">Firma Manuscrita</span>
    </button>
    <button 
      type="button" 
      class="btn btn-lg mode-btn" 
      [class.btn-primary]="modoFirma === 'cargar'"
      [class.btn-outline-primary]="modoFirma !== 'cargar'"
      (click)="cambiarModo('cargar')">
      <i class="fa fa-upload me-2"></i>
      <span class="btn-text">Subir Imagen</span>
    </button>
  </div>

  <!-- Área de dibujo -->
  <div *ngIf="modoFirma === 'dibujar'" class="signature-section">
    <div class="signature-wrapper">
      <div class="signature-instructions mb-2">
        <i class="fa fa-info-circle me-1"></i>
        <small>Dibuja tu firma en el área a continuación</small>
      </div>
      
      <div class="signature-box">
        <canvas 
          #signaturePad
          class="signature-canvas"
          (mousedown)="startDrawing($event)"
          (mousemove)="draw($event)"
          (mouseup)="stopDrawing()"
          (mouseleave)="stopDrawing()"
          (touchstart)="startDrawing($event)"
          (touchmove)="draw($event)"
          (touchend)="stopDrawing()">
        </canvas>
        <div class="signature-line"></div>
      </div>
      
      <div class="d-flex justify-content-center gap-2 mt-3">
        <button 
          type="button" 
          class="btn btn-outline-danger"
          (click)="limpiarFirma()"
          [disabled]="guardando">
          <i class="fa fa-eraser me-2"></i>Limpiar
        </button>
      </div>
    </div>
  </div>

  <!-- Área de carga de archivo -->
  <div *ngIf="modoFirma === 'cargar'" class="upload-section">
    <input 
      type="file" 
      class="d-none" 
      #fileInput
      (change)="onArchivoSeleccionado($event)"
      accept="image/png,image/jpeg,image/jpg">
    
    <div 
      class="upload-box" 
      [class.has-file]="previewFirma"
      [class.drag-over]="false"
      (click)="fileInput.click()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      
      <div *ngIf="!previewFirma" class="upload-placeholder">
        <div class="upload-icon mb-3">
          <i class="fa fa-cloud-upload"></i>
        </div>
        <h6 class="mb-2">Arrastra tu imagen aquí</h6>
        <p class="text-muted mb-3">o</p>
        <button type="button" class="btn btn-outline-primary btn-sm">
          <i class="fa fa-folder-open me-2"></i>Seleccionar archivo
        </button>
        <p class="upload-hint mt-3 mb-0">
          <small class="text-muted">Formatos permitidos: PNG, JPG, JPEG</small>
        </p>
      </div>
      
      <div *ngIf="previewFirma" class="preview-image">
        <div class="preview-header mb-2">
          <span class="badge bg-success">
            <i class="fa fa-check me-1"></i>Firma cargada
          </span>
        </div>
        <img [src]="previewFirma" alt="Preview firma">
        <button 
          type="button" 
          class="btn-remove"
          title="Eliminar firma"
          (click)="limpiarFirma(); $event.stopPropagation()">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Mensaje de error -->
  <div *ngIf="mensajeError" class="alert alert-danger mt-3" role="alert">
    <i class="fa fa-exclamation-triangle me-2"></i>{{ mensajeError }}
  </div>

</div>
